<script setup lang="ts">
import Layout from '@/Layouts/Frontend/Layout.vue';
import {Head, usePage} from "@inertiajs/vue3";
import {computed} from "vue";
import {PageProps} from "@/Types";
import Button from "@/Components/Frontend/Elements/Button.vue";
import PageTitle from "@/Components/Frontend/Elements/PageTitle.vue";
// --- Props
defineProps<{
    status: number;
    title: string;
    message: string;
}>();
// --- Data
// --- Computed
const initialPageProps = computed(() => <PageProps>usePage().props)
// --- Methods
// --- Watch
// --- Provide
</script>

<template>
    <Layout robots="noindex, nofollow" :use-container="false">
        <Head :title="`${status} - ${title} - ${initialPageProps.app_name}`" />

        <div class="container text-center">
            <div class="oops">Oops!</div>
            <PageTitle :title="`${status} - ${title}`" class="uppercase font-bold" />
        </div>

        <div class="bg-grey p-12">
            <div class="container">
                <div class="text-center tracking-[1.2px]]">
                    <p class="mb-6">
                        {{ message }}
                    </p>

                    <Button
                        :href="route('frontend.homepage')"
                        bg-color="black"
                        text-color="white"
                        class="uppercase"
                    >
                        {{ $t("Go Home") }}
                    </Button>
                </div>
            </div>
        </div>
    </Layout>
</template>

<style lang="postcss" scoped>
    .oops {
        @apply text-[75px] lg:text-[130px]
        mt-10
        font-black
        text-white;
        text-shadow: -1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black;
    }
</style>
